import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {EditSectionModal} from './edit-section.modal';

type Props = {
    onSave: () => void,
    conferenceId: number,
    sectionId: number,
};

export const EditSection = ({onSave, conferenceId, sectionId}: Props) => {
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}><b>Edit Section</b></FlatButton>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 600}}}>
                <EditSectionModal
                    conferenceId={conferenceId}
                    onClose={onClose}
                    onSave={onSave}
                    sectionId={sectionId}
                />
            </Dialog>
        </>
    );
};
